import { UnsavedChangesModalResult } from '@/models/ui/unsaved-changed-modal-result';
import UnsavedChangesModalComponent from '@/shared/components/unsaved-changes-modal/unsaved-changes-modal';
import { Component, Provide, Ref, Vue } from 'vue-property-decorator';
import { UNSAVED_CHANGES_CONFIRMATION_TOKEN } from '@/shared/utils/unsaved-changes-token';
import { appSettingsModule } from '@/store/app-settings-module';
import { isNull } from '@/shared/utils/utils';
import UserMenu from '@/shared/components/user-menu/user-menu';

@Component({
    components: {
        UserMenu
    }
})
export default class DefaultLayout extends Vue {
    @Ref() readonly unsavedChangesModal!: UnsavedChangesModalComponent
    
    mailWizzInstancesLoading = true

    get mailWizzDependent() { return this.$route.matched.some(p => p.meta.mailWizzDependent) }
    get mailWizzSelected() { return !isNull(appSettingsModule.activeMailWizz) }

    @Provide(UNSAVED_CHANGES_CONFIRMATION_TOKEN)
    showUnsavedChangedModal(message: string): Promise<UnsavedChangesModalResult> {
        return this.unsavedChangesModal.show(message);
    }
}
